import React from 'react'
import { WContainer } from '@components/atoms'
import styles from './HighlightsSection.module.sass'
import { GraphCard } from '@components/molecules'
import { MetricaType } from '@gql/graphql'

interface Props {
  metriche?: MetricaType[]
  editMode?: boolean
  className?: string
}

const HighlightsSection = (props: Props) => {
  const { metriche = [], editMode = false, className = '' } = props

  return metriche.length > 0 ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <WContainer>
        <div className={styles.list}>
          {metriche.length > 0 && metriche.map((x) => <GraphCard metrica={x} />)}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default HighlightsSection
